import React, {useEffect, useState} from "react";
import {Clock, Filter, Globe, Grid, List, Map, MapPin, Phone, Search, Shield, Star,} from "lucide-react";
import {Header} from "../components/Header";

export const YellowPageSearchResults = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [viewMode, setViewMode] = useState("grid"); // 'grid', 'list', 'map'
    const [showFilters, setShowFilters] = useState(true);
    const [sortBy, setSortBy] = useState("relevance");
    const [currentPage, setCurrentPage] = useState(1);
    const [filteredResults, setFilteredResults] = useState([]);

    // Filter states
    const [filters, setFilters] = useState({
        entityType: "",
        category: "",
        subCategory: "",
        priceRange: "",
        verified: false,
        openNow: false,
        location: "",
        distance: 10,
        minRating: 0,
    });

    // Dummy data based on schema
    const dummyEntities = [
        {
            _id: "1",
            entityName: "Spice Route Restaurant",
            entityType: "business",
            category: {main: "restaurants", sub: "maharashtrian-cuisine"},
            description:
                "Authentic Maharashtrian cuisine with traditional recipes passed down through generations. We serve the finest misal pav, vada pav, and thali in the city.",
            priceRange: "mid-range",
            entityContactDetails: {
                mobileNumber: "+91-9876543210",
                whatsAppNumber: "+91-9876543210",
                emailId: "info@spiceroute.com",
                websiteLink: "https://spiceroute.com",
                address: {
                    street: "123 FC Road",
                    landmark: "Near Deccan Gymkhana",
                    locality: "Shivajinagar",
                    pincode: "411005",
                },
            },
            photos: {
                profileAvatarOrLogo: {
                    url: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=300",
                },
                profileCover: [
                    {
                        url: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=800",
                    },
                ],
            },
            operatingHours: [
                {
                    day: "monday",
                    opens: {en: "11:00 AM"},
                    closes: {en: "10:00 PM"},
                    closed: false,
                },
                {
                    day: "tuesday",
                    opens: {en: "11:00 AM"},
                    closes: {en: "10:00 PM"},
                    closed: false,
                },
            ],
            verification: {isVerified: true, verifiedAt: new Date()},
            isPublished: true,
            rating: 4.5,
            reviewCount: 234,
            distance: 1.2,
        },
        {
            _id: "2",
            entityName: "TechFix Solutions",
            entityType: "service",
            category: {main: "technology", sub: "computer-repair"},
            description:
                "Professional computer and laptop repair services. We fix all brands with genuine parts and provide warranty on our work.",
            priceRange: "budget-friendly",
            entityContactDetails: {
                mobileNumber: "+91-9123456789",
                whatsAppNumber: "+91-9123456789",
                emailId: "support@techfix.com",
                address: {
                    street: "456 Karve Road",
                    landmark: "Opposite Bank of Maharashtra",
                    locality: "Erandwane",
                    pincode: "411004",
                },
            },
            photos: {
                profileAvatarOrLogo: {
                    url: "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=300",
                },
                profileCover: [
                    {
                        url: "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=800",
                    },
                ],
            },
            operatingHours: [
                {
                    day: "monday",
                    opens: {en: "9:00 AM"},
                    closes: {en: "7:00 PM"},
                    closed: false,
                },
            ],
            verification: {isVerified: true, verifiedAt: new Date()},
            isPublished: true,
            rating: 4.2,
            reviewCount: 89,
            distance: 2.5,
        },
        {
            _id: "3",
            entityName: "Radiant Beauty Salon",
            entityType: "service",
            category: {main: "beauty-wellness", sub: "salon"},
            description:
                "Full-service beauty salon offering haircuts, styling, facials, manicures, and pedicures. Experience luxury treatments in a relaxing environment.",
            priceRange: "premium",
            entityContactDetails: {
                mobileNumber: "+91-9234567890",
                whatsAppNumber: "+91-9234567890",
                emailId: "book@radiantbeauty.com",
                websiteLink: "https://radiantbeauty.com",
                address: {
                    street: "789 MG Road",
                    landmark: "Above Cafe Coffee Day",
                    locality: "Camp",
                    pincode: "411001",
                },
            },
            photos: {
                profileAvatarOrLogo: {
                    url: "https://images.unsplash.com/photo-1560066984-138dadb4c035?w=300",
                },
                profileCover: [
                    {
                        url: "https://images.unsplash.com/photo-1560066984-138dadb4c035?w=800",
                    },
                ],
            },
            operatingHours: [
                {
                    day: "tuesday",
                    opens: {en: "10:00 AM"},
                    closes: {en: "8:00 PM"},
                    closed: false,
                },
            ],
            verification: {isVerified: true, verifiedAt: new Date()},
            isPublished: true,
            rating: 4.7,
            reviewCount: 156,
            distance: 0.8,
        },
        {
            _id: "4",
            entityName: "Quick Delivery Services",
            entityType: "service",
            category: {main: "logistics", sub: "courier"},
            description:
                "Fast and reliable courier and delivery services across Maharashtra. Same-day delivery available within the city.",
            priceRange: "budget-friendly",
            entityContactDetails: {
                mobileNumber: "+91-9345678901",
                whatsAppNumber: "+91-9345678901",
                emailId: "orders@quickdelivery.com",
                address: {
                    street: "321 Tilak Road",
                    landmark: "Near Railway Station",
                    locality: "Sadashiv Peth",
                    pincode: "411030",
                },
            },
            photos: {
                profileAvatarOrLogo: {
                    url: "https://images.unsplash.com/photo-1566576912321-d58ddd7a6088?w=300",
                },
                profileCover: [
                    {
                        url: "https://images.unsplash.com/photo-1566576912321-d58ddd7a6088?w=800",
                    },
                ],
            },
            operatingHours: [
                {
                    day: "monday",
                    opens: {en: "8:00 AM"},
                    closes: {en: "9:00 PM"},
                    closed: false,
                },
            ],
            verification: {isVerified: false, verifiedAt: new Date()},
            isPublished: true,
            rating: 3.9,
            reviewCount: 67,
            distance: 3.1,
        },
        {
            _id: "5",
            entityName: "Green Grocery Store",
            entityType: "business",
            category: {main: "retail", sub: "grocery"},
            description:
                "Fresh organic vegetables, fruits, and daily essentials. We source directly from farmers to ensure quality and freshness.",
            priceRange: "mid-range",
            entityContactDetails: {
                mobileNumber: "+91-9456789012",
                whatsAppNumber: "+91-9456789012",
                address: {
                    street: "654 Prabhat Road",
                    landmark: "Near SBI Bank",
                    locality: "Deccan",
                    pincode: "411004",
                },
            },
            photos: {
                profileAvatarOrLogo: {
                    url: "https://images.unsplash.com/photo-1542838132-92c53300491e?w=300",
                },
                profileCover: [
                    {
                        url: "https://images.unsplash.com/photo-1542838132-92c53300491e?w=800",
                    },
                ],
            },
            operatingHours: [
                {
                    day: "sunday",
                    opens: {en: "7:00 AM"},
                    closes: {en: "10:00 PM"},
                    closed: false,
                },
            ],
            verification: {isVerified: true, verifiedAt: new Date()},
            isPublished: true,
            rating: 4.3,
            reviewCount: 123,
            distance: 1.8,
        },
        {
            _id: "6",
            entityName: "Elite Fitness Gym",
            entityType: "service",
            category: {main: "fitness", sub: "gym"},
            description:
                "State-of-the-art fitness center with modern equipment, personal trainers, and group classes. Open 24/7 for your convenience.",
            priceRange: "premium",
            entityContactDetails: {
                mobileNumber: "+91-9567890123",
                whatsAppNumber: "+91-9567890123",
                emailId: "info@elitefitness.com",
                websiteLink: "https://elitefitness.com",
                address: {
                    street: "987 Baner Road",
                    landmark: "Next to HDFC Bank",
                    locality: "Baner",
                    pincode: "411045",
                },
            },
            photos: {
                profileAvatarOrLogo: {
                    url: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=300",
                },
                profileCover: [
                    {
                        url: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800",
                    },
                ],
            },
            operatingHours: [
                {
                    day: "monday",
                    opens: {en: "24 Hours"},
                    closes: {en: "24 Hours"},
                    closed: false,
                },
            ],
            verification: {isVerified: true, verifiedAt: new Date()},
            isPublished: true,
            rating: 4.6,
            reviewCount: 189,
            distance: 4.2,
        },
    ];

    // Categories for filter dropdown
    const categories = [
        {value: "restaurants", label: "Restaurants"},
        {value: "technology", label: "Technology"},
        {value: "beauty-wellness", label: "Beauty & Wellness"},
        {value: "logistics", label: "Logistics"},
        {value: "retail", label: "Retail"},
        {value: "fitness", label: "Fitness"},
    ];

    const priceRanges = [
        {value: "budget-friendly", label: "Budget Friendly (₹)"},
        {value: "mid-range", label: "Mid Range (₹₹)"},
        {value: "premium", label: "Premium (₹₹₹)"},
    ];

    useEffect(() => {
        // Filter and sort logic
        let results = dummyEntities.filter((entity) => {
            if (filters.entityType && entity.entityType !== filters.entityType)
                return false;
            if (filters.category && entity.category.main !== filters.category)
                return false;
            if (filters.priceRange && entity.priceRange !== filters.priceRange)
                return false;
            if (filters.verified && !entity.verification.isVerified)
                return false;
            if (filters.minRating && entity.rating < filters.minRating)
                return false;
            if (filters.distance && entity.distance > filters.distance)
                return false;

            // Text search
            if (searchTerm) {
                const searchLower = searchTerm.toLowerCase();
                return (
                    entity.entityName.toLowerCase().includes(searchLower) ||
                    entity.description.toLowerCase().includes(searchLower) ||
                    entity.category.main.toLowerCase().includes(searchLower)
                );
            }

            return true;
        });

        // Sort results
        switch (sortBy) {
            case "rating":
                results.sort((a, b) => b.rating - a.rating);
                break;
            case "distance":
                results.sort((a, b) => a.distance - b.distance);
                break;
            case "newest":
                results.sort(
                    (a, b) =>
                        new Date(b.createdAt || Date.now()) -
                        new Date(a.createdAt || Date.now())
                );
                break;
            default:
                break;
        }

        setFilteredResults(results);
    }, [filters, searchTerm, sortBy]);

    const handleFilterChange = (key, value) => {
        setFilters((prev) => ({...prev, [key]: value}));
        setCurrentPage(1);
    };

    const clearFilters = () => {
        setFilters({
            entityType: "",
            category: "",
            subCategory: "",
            priceRange: "",
            verified: false,
            openNow: false,
            location: "",
            distance: 10,
            minRating: 0,
        });
    };

    const renderStars = (rating) => {
        return [...Array(5)].map((_, i) => (
            <Star
                key={i}
                className={`w-4 h-4 ${
                    i < Math.floor(rating)
                        ? "text-yellow-400 fill-current"
                        : "text-gray-300"
                }`}
            />
        ));
    };

    const EntityCard = ({entity, isListView = false}) => (
        <div
            className={`bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden ${
                isListView ? "flex" : ""
            }`}
        >
            <div
                className={`${
                    isListView ? "w-48 flex-shrink-0" : "w-full h-48"
                } relative`}
            >
                <img
                    src={
                        entity.photos?.profileCover?.[0]?.url ||
                        entity.photos?.profileAvatarOrLogo?.url
                    }
                    alt={entity.entityName}
                    className="w-full h-full object-cover"
                />
                <div className="absolute top-3 right-3 flex gap-2">
                    {entity.verification?.isVerified && (
                        <div
                            className="bg-green-500 text-white px-2 py-1 rounded-full text-xs font-custom-bold flex items-center gap-1">
                            <Shield className="w-3 h-3"/>
                            Verified
                        </div>
                    )}
                    <div
                        className="bg-orange-500 text-white px-2 py-1 rounded-full text-xs font-custom-bold capitalize">
                        {entity.entityType}
                    </div>
                </div>
            </div>

            <div className="p-6 flex-1">
                <div className="flex justify-between items-start mb-2">
                    <h3 className="text-xl font-custom-bold text-gray-900 line-clamp-1">
                        {entity.entityName}
                    </h3>
                    <div className="flex items-center gap-2 ml-4">
                        <div className="flex items-center">
                            {renderStars(entity.rating)}
                        </div>
                        <span className="text-sm font-custom-medium text-gray-700">
							{entity.rating}
						</span>
                        <span className="text-xs text-gray-500">
							({entity.reviewCount})
						</span>
                    </div>
                </div>

                <div className="flex items-center gap-4 text-sm text-gray-600 mb-3">
					<span className="capitalize bg-gray-100 px-2 py-1 rounded">
						{entity.category.main.replace("-", " ")}
					</span>
                    {entity.priceRange && (
                        <span className="text-orange-600 font-custom-medium">
							{entity.priceRange === "budget-friendly"
                                ? "₹"
                                : entity.priceRange === "mid-range"
                                    ? "₹₹"
                                    : "₹₹₹"}
						</span>
                    )}
                    <div className="flex items-center gap-1">
                        <MapPin className="w-4 h-4 text-gray-400"/>
                        <span>{entity.distance} km</span>
                    </div>
                </div>

                <p className="text-gray-600 text-sm mb-4 line-clamp-2">
                    {entity.description}
                </p>

                <div className="space-y-2 mb-4">
                    <div className="flex items-center gap-2 text-sm">
                        <MapPin className="w-4 h-4 text-gray-400"/>
                        <span className="text-gray-700">
							{entity.entityContactDetails.address.locality},{" "}
                            {entity.entityContactDetails.address.pincode}
						</span>
                    </div>

                    {entity.operatingHours?.[0] &&
                        !entity.operatingHours[0].closed && (
                            <div className="flex items-center gap-2 text-sm">
                                <Clock className="w-4 h-4 text-green-500"/>
                                <span className="text-green-600 font-custom-medium">
									Open Now
								</span>
                                <span className="text-gray-600">
									• Closes{" "}
                                    {entity.operatingHours[0].closes.en}
								</span>
                            </div>
                        )}
                </div>

                <div className="flex items-center justify-between">
                    <div className="flex gap-2">
                        <button
                            className="flex items-center gap-1 text-orange-600 hover:text-orange-700 text-sm font-custom-medium">
                            <Phone className="w-4 h-4"/>
                            Call
                        </button>
                        {entity.entityContactDetails.websiteLink && (
                            <button
                                className="flex items-center gap-1 text-blue-600 hover:text-blue-700 text-sm font-custom-medium">
                                <Globe className="w-4 h-4"/>
                                Website
                            </button>
                        )}
                    </div>
                    <button
                        className="bg-orange-500 text-white px-4 py-2 rounded-lg text-sm font-custom-medium hover:bg-orange-600 transition-colors">
                        View Details
                    </button>
                </div>
            </div>
        </div>
    );

    return (
        <div
            className={`min-h-[100dvh] h-[100dvh] max-h-[100dvh]
                min-w-full w-full max-w-full 
                bg-white flex flex-col justify-end`}
        >
            {/* Header */}
            <Header/>

            {/* Main Content */}
            <div
                className="bg-orange-50 text-gray-800 min-h-screen
                    flex flex-col justify-between thin-scrollbar overflow-y-scroll min-w-full w-full max-w-full

                    portrait:pt-[4.75rem] portrait:sm:pt-[6.25rem] portrait:jk:pt-[5.75rem]

                    portrait:min-h-[100dvh] portrait:h-[100dvh] portrait:max-h-[100dvh]

                    landscape:pt-[3.5rem] landscape:jk:pt-[4.5rem]

                    landscape:min-h-[100dvh] landscape:h-[100dvh] landscape:max-h-[100dvh]

                    portrait:pb-[0.75rem] portrait:pl-[0.75rem] portrait:pr-[0.75rem]
                    landscape:pb-[0.5rem] landscape:pl-[0.5rem] landscape:pr-[0.5rem]

                    portrait:gap-[0.75rem] landscape:gap-[0.5rem]"
            >
                {/* Search Header */}
                <div className="bg-white shadow-sm border-b">
                    <div className="container mx-auto px-4 py-4">
                        <div className="flex flex-col lg:flex-row gap-4 items-center">
                            <div className="flex-1 relative">
                                <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 w-5 h-5"/>
                                <input
                                    type="text"
                                    placeholder="Search businesses, services..."
                                    value={searchTerm}
                                    onChange={(e) =>
                                        setSearchTerm(e.target.value)
                                    }
                                    className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                                />
                            </div>

                            <div className="flex items-center gap-4">
                                <select
                                    value={sortBy}
                                    onChange={(e) => setSortBy(e.target.value)}
                                    className="px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500"
                                >
                                    <option value="relevance">
                                        Sort by Relevance
                                    </option>
                                    <option value="rating">
                                        Sort by Rating
                                    </option>
                                    <option value="distance">
                                        Sort by Distance
                                    </option>
                                    <option value="newest">
                                        Sort by Newest
                                    </option>
                                </select>

                                <div className="flex bg-gray-100 rounded-lg p-1">
                                    <button
                                        onClick={() => setViewMode("grid")}
                                        className={`p-2 rounded ${
                                            viewMode === "grid"
                                                ? "bg-white shadow-sm"
                                                : ""
                                        }`}
                                    >
                                        <Grid className="w-5 h-5"/>
                                    </button>
                                    <button
                                        onClick={() => setViewMode("list")}
                                        className={`p-2 rounded ${
                                            viewMode === "list"
                                                ? "bg-white shadow-sm"
                                                : ""
                                        }`}
                                    >
                                        <List className="w-5 h-5"/>
                                    </button>
                                    <button
                                        onClick={() => setViewMode("map")}
                                        className={`p-2 rounded ${
                                            viewMode === "map"
                                                ? "bg-white shadow-sm"
                                                : ""
                                        }`}
                                    >
                                        <Map className="w-5 h-5"/>
                                    </button>
                                </div>

                                <button
                                    onClick={() => setShowFilters(!showFilters)}
                                    className="flex items-center gap-2 px-4 py-3 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors"
                                >
                                    <Filter className="w-5 h-5"/>
                                    Filters
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Filters | Results */}
                <div className="container mx-auto px-4 py-6">
                    <div className="flex gap-6">
                        {/* Filters Sidebar */}
                        {showFilters && (
                            <div className="w-80 bg-white rounded-xl shadow-md p-6 h-fit">
                                <div className="flex items-center justify-between mb-6">
                                    <h3 className="text-lg font-custom-bold text-gray-900">
                                        Filters
                                    </h3>
                                    <button
                                        onClick={clearFilters}
                                        className="text-sm text-orange-600 hover:text-orange-700 font-custom-medium"
                                    >
                                        Clear All
                                    </button>
                                </div>

                                <div className="space-y-6">
                                    {/* Entity Type */}
                                    <div>
                                        <label className="block text-sm font-custom-medium text-gray-700 mb-2">
                                            Type
                                        </label>
                                        <select
                                            value={filters.entityType}
                                            onChange={(e) =>
                                                handleFilterChange(
                                                    "entityType",
                                                    e.target.value
                                                )
                                            }
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500"
                                        >
                                            <option value="">All Types</option>
                                            <option value="business">
                                                Business
                                            </option>
                                            <option value="service">
                                                Service
                                            </option>
                                        </select>
                                    </div>

                                    {/* Category */}
                                    <div>
                                        <label className="block text-sm font-custom-medium text-gray-700 mb-2">
                                            Category
                                        </label>
                                        <select
                                            value={filters.category}
                                            onChange={(e) =>
                                                handleFilterChange(
                                                    "category",
                                                    e.target.value
                                                )
                                            }
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500"
                                        >
                                            <option value="">
                                                All Categories
                                            </option>
                                            {categories.map((cat) => (
                                                <option
                                                    key={cat.value}
                                                    value={cat.value}
                                                >
                                                    {cat.label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    {/* Price Range */}
                                    <div>
                                        <label className="block text-sm font-custom-medium text-gray-700 mb-2">
                                            Price Range
                                        </label>
                                        <select
                                            value={filters.priceRange}
                                            onChange={(e) =>
                                                handleFilterChange(
                                                    "priceRange",
                                                    e.target.value
                                                )
                                            }
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500"
                                        >
                                            <option value="">
                                                All Price Ranges
                                            </option>
                                            {priceRanges.map((price) => (
                                                <option
                                                    key={price.value}
                                                    value={price.value}
                                                >
                                                    {price.label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    {/* Rating */}
                                    <div>
                                        <label className="block text-sm font-custom-medium text-gray-700 mb-2">
                                            Minimum Rating
                                        </label>
                                        <select
                                            value={filters.minRating}
                                            onChange={(e) =>
                                                handleFilterChange(
                                                    "minRating",
                                                    parseFloat(e.target.value)
                                                )
                                            }
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500"
                                        >
                                            <option value={0}>
                                                Any Rating
                                            </option>
                                            <option value={3}>3+ Stars</option>
                                            <option value={4}>4+ Stars</option>
                                            <option value={4.5}>
                                                4.5+ Stars
                                            </option>
                                        </select>
                                    </div>

                                    {/* Distance */}
                                    <div>
                                        <label className="block text-sm font-custom-medium text-gray-700 mb-2">
                                            Distance: {filters.distance} km
                                        </label>
                                        <input
                                            type="range"
                                            min="1"
                                            max="20"
                                            value={filters.distance}
                                            onChange={(e) =>
                                                handleFilterChange(
                                                    "distance",
                                                    parseInt(e.target.value)
                                                )
                                            }
                                            className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer slider"
                                        />
                                        <div className="flex justify-between text-xs text-gray-500 mt-1">
                                            <span>1 km</span>
                                            <span>20 km</span>
                                        </div>
                                    </div>

                                    {/* Checkboxes */}
                                    <div className="space-y-3">
                                        <label className="flex items-center">
                                            <input
                                                type="checkbox"
                                                checked={filters.verified}
                                                onChange={(e) =>
                                                    handleFilterChange(
                                                        "verified",
                                                        e.target.checked
                                                    )
                                                }
                                                className="rounded border-gray-300 text-orange-500 focus:ring-orange-500"
                                            />
                                            <span className="ml-2 text-sm text-gray-700">
												Verified Only
											</span>
                                        </label>

                                        <label className="flex items-center">
                                            <input
                                                type="checkbox"
                                                checked={filters.openNow}
                                                onChange={(e) =>
                                                    handleFilterChange(
                                                        "openNow",
                                                        e.target.checked
                                                    )
                                                }
                                                className="rounded border-gray-300 text-orange-500 focus:ring-orange-500"
                                            />
                                            <span className="ml-2 text-sm text-gray-700">
												Open Now
											</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Results Section */}
                        <div className="flex-1">
                            {/* Results Header */}
                            <div className="flex justify-between items-center mb-6">
                                <div>
                                    <h2 className="text-2xl font-custom-bold text-gray-900">
                                        Search Results
                                    </h2>
                                    <p className="text-gray-600">
                                        {
                                            searchTerm !== "" &&
                                            `Found ${filteredResults.length} results for "${searchTerm}"`
                                        }
                                    </p>
                                </div>
                            </div>

                            {/* Results Grid/List */}
                            {viewMode === "map" ? (
                                <div className="bg-white rounded-xl shadow-md p-8 text-center">
                                    <Map className="w-16 h-16 text-gray-400 mx-auto mb-4"/>
                                    <h3 className="text-lg font-custom-medium text-gray-900 mb-2">
                                        Map View
                                    </h3>
                                    <p className="text-gray-600">
                                        Interactive map with business locations
                                        would be displayed here.
                                    </p>
                                </div>
                            ) : (
                                <div
                                    className={`${
                                        viewMode === "grid"
                                            ? "grid grid-cols-1 lg:grid-cols-2 gap-6"
                                            : "space-y-6"
                                    }`}
                                >
                                    {filteredResults.length > 0 ? (
                                        filteredResults.map((entity) => (
                                            <EntityCard
                                                key={entity._id}
                                                entity={entity}
                                                isListView={viewMode === "list"}
                                            />
                                        ))
                                    ) : (
                                        <div className="bg-white rounded-xl shadow-md p-8 text-center">
                                            <Search className="w-16 h-16 text-gray-400 mx-auto mb-4"/>
                                            <h3 className="text-lg font-custom-medium text-gray-900 mb-2">
                                                No results found
                                            </h3>
                                            <p className="text-gray-600 mb-4">
                                                Try adjusting your search terms
                                                or filters to find what you're
                                                looking for.
                                            </p>
                                            <button
                                                onClick={clearFilters}
                                                className="bg-orange-500 text-white px-4 py-2 rounded-lg hover:bg-orange-600 transition-colors"
                                            >
                                                Clear Filters
                                            </button>
                                        </div>
                                    )}
                                </div>
                            )}

                            {/* Pagination */}
                            {filteredResults.length > 0 && (
                                <div className="mt-8 flex justify-center">
                                    <div className="flex items-center gap-2">
                                        <button
                                            className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors">
                                            Previous
                                        </button>
                                        <span className="px-4 py-2 bg-orange-500 text-white rounded-lg">
											1
										</span>
                                        <button
                                            className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors">
                                            2
                                        </button>
                                        <button
                                            className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors">
                                            3
                                        </button>
                                        <button
                                            className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors">
                                            Next
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
